import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { FormsModule,ReactiveFormsModule  } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { NzTreeSelectModule } from 'ng-zorro-antd/tree-select';
import { FeatherIconsComponent } from './components/feather-icons/feather-icons.component';
import { FooterComponent } from './components/footer/footer.component';
import { HeaderComponent } from './components/header/header.component';
import { SidebarComponent } from './components/sidebar/sidebar.component';
import { ToggleFullscreenDirective } from "./directives/fullscreen.directive";
import { ContentLayoutComponent } from './layout/content-layout/content-layout.component';
import { NavService } from './service/nav.service';
import { WINDOW_PROVIDERS } from './service/windows.service';
import { BreadcrumbComponent } from './components/breadcrumb/breadcrumb.component';
import { RightSidebarComponent } from './components/right-sidebar/right-sidebar.component';
import { TableService } from './service/table.service';
import { NgbdSortableHeader } from './directives/NgbdSortableHeader';
import { FileUploadComponent } from './components/file-upload/file-upload.component';
import { FileViewerComponent } from './components/file-viewer/file-viewer.component';
import { FileListComponent } from './components/file-list/file-list.component';
import { StepperComponent } from './components/stepper/stepper.component';
import { BatchConfigurationComponent } from './components/batch-configuration/batch-configuration.component';
import { BatchConfigurationPlantillaComponent } from './components/batch-configuration-plantilla/batch-configuration-plantilla.component';
import { BatchConfigurationExternaComponent } from './components/batch-configuration-externa/batch-configuration-externa.component';
import { TablePaginatorComponent } from './components/table-paginator/table-paginator.component';
import { ErrorMessageComponent } from './components/validates-forms/validate-form.component';
import { NgxDropzoneModule } from 'ngx-dropzone';
import { ToastrModule } from 'ngx-toastr';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { NotFoundComponent } from './components/not-found/not-found.component';
import { SearchCertificateComponent } from './components/search-certificate/search-certificate';
import { NgbProgressbarModule, NgbDropdownModule  } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { SpinnerLoadingComponent } from './components/spinner-loading/spinner-loading.component';
import { GroupsComponent } from './components/groups/groups.component';
import { FormChangePasswordComponent } from './components/form-change-password/form-change-password.component';
import { ImportUsersComponent } from './components/import-users/import-users.component';
import { CambioContrasenaComponent } from './components/cambio-contrasena/cambio-contrasena.component';
import { PasswordRequirementsComponent } from './components/password-requirements/password-requirements.component';
import { RecoverPasswordComponent } from './components/recover-password/recover-password.component';
import { AutocompleteSearchComponent } from './components/search-autocomplete/search-autocomplete.component';
import { PermisosModalComponent } from './components/permisos-acceso/permisos-modal.component';
import { UsuariosGrupoModalComponent } from './components/permisos-acceso/usuarios-grupo-modal/usuarios-grupo-modal.component';
import { SearchGroupComponent } from './components/search-group/search-group.component';
import { ConfigPanelComponent } from './components/configPanelTab/config-panel.component';
import { FormMFAComponent } from './components/form-mfa/form-mfa.component';
import { ResetMFAComponent } from './components/reset-mfa/reset-mfa.component';




@NgModule({
  declarations: [
    ToggleFullscreenDirective,
    FeatherIconsComponent,
    FooterComponent,
    HeaderComponent,
    SidebarComponent,
    ContentLayoutComponent,
    BreadcrumbComponent,
    RightSidebarComponent,
    NgbdSortableHeader,
    FileUploadComponent,
    FileViewerComponent,
    FileListComponent,
    BatchConfigurationComponent,
    BatchConfigurationPlantillaComponent,
    BatchConfigurationExternaComponent,
    StepperComponent,
    TablePaginatorComponent,
    ErrorMessageComponent,
    NotFoundComponent,
    SearchCertificateComponent,
    SpinnerLoadingComponent,
    FormChangePasswordComponent,
    FormMFAComponent,
    RecoverPasswordComponent,
    ImportUsersComponent,
    CambioContrasenaComponent,
    ResetMFAComponent , 
    PasswordRequirementsComponent,
    AutocompleteSearchComponent,
    GroupsComponent,
    PermisosModalComponent,    
    UsuariosGrupoModalComponent,
    SearchGroupComponent,
    ConfigPanelComponent
  ],
  imports: [
    FormsModule,
    CommonModule,
    RouterModule,
    NgxDropzoneModule,
    ToastrModule.forRoot({ enableHtml: true }),
    PdfViewerModule,
    ReactiveFormsModule,
    NgbProgressbarModule,
    NgbDropdownModule,
    NgSelectModule,
    NzTreeSelectModule,
  ],
  providers: [NavService, TableService, WINDOW_PROVIDERS],
  exports: [
    FeatherIconsComponent, 
    ToggleFullscreenDirective,
    NgbdSortableHeader,
    FileUploadComponent,
    FileViewerComponent,
    FileListComponent,
    BatchConfigurationComponent,
    BatchConfigurationPlantillaComponent,
    BatchConfigurationExternaComponent,
    StepperComponent,
    SearchCertificateComponent,
    TablePaginatorComponent,
    ErrorMessageComponent,
    SpinnerLoadingComponent , 
    FormChangePasswordComponent,
    FormMFAComponent,
    RecoverPasswordComponent,
    ImportUsersComponent,
    CambioContrasenaComponent,
    ResetMFAComponent , 
    PasswordRequirementsComponent,
    NgSelectModule,
    GroupsComponent,
    NgSelectModule,
    NzTreeSelectModule,
    AutocompleteSearchComponent , 
    SearchGroupComponent,
    ConfigPanelComponent
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA // ✅ AQUÍ
  ]
})
export class SharedModule { }
